import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth ,db} from "../firebase";
import { useNavigate } from "react-router-dom";
import "./Signup.css";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";


export default function Signup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
const handleSignup = async () => {
  if (!email || !password || !confirmPassword) {
    setError("All fields are required");
    return;
  }

  if (password !== confirmPassword) {
    setError("Passwords do not match");
    return;
  }

  try {
    setLoading(true);
    setError("");

    // 1️⃣ Create user in Firebase Auth
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user = userCredential.user;

    // 2️⃣ Save user data in Firestore
    // eslint-disable-next-line no-undef
    await setDoc(doc(db, "users", user.uid), {
      uid: user.uid,
      email: user.email,
      // eslint-disable-next-line no-undef
      createdAt: serverTimestamp(),
    });

    // 3️⃣ Redirect to login
    navigate("/login");
  } catch (err) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="signup-wrapper">
      <div className="yellow-circle"></div>

      <div className="signup-card">
        <h1>Create Account</h1>
        <p className="subtitle">Join us and get started</p>

        {error && <p className="error">{error}</p>}

        <div className="input-group">
          <input
            type="email"
            placeholder="Email Address"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="input-group">
          <input
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="input-group">
          <input
            type="password"
            placeholder="Confirm Password"
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        <button className="signup-btn" onClick={handleSignup} disabled={loading}>
          {loading ? "Creating..." : "Create Account"}
        </button>

        <div className="login-text">
          Already have an account?{" "}
          <span onClick={() => navigate("/login")}>Login</span>
        </div>
      </div>
    </div>
  );
}
